// TableHeader.jsx

import React from 'react';

// CSS
import './TableHeader.css';

// Components
import TableHeaderCell from 'views/table/components/TableHeaderCell';
import TableHeaderCorner from 'views/table/components/TableHeaderCorner';

/**
 * TableHeader
 *
 * @returns {ReactNode} The rendered component.
 */
const TableHeader = ({
    showCheckboxes = true,
    columns,
    onResizeStart,
    onSortAscending,
    onSortDescending,
    allSelected,
    onToggleAll,
    draggingKey,
    dragOverKey,
    onDragStart,
    onDragOver,
    onDrop,
    onDragEnd,
}) => {

  // ----- RENDER ----- //

  return (

        <div className="table-view-header-row">

        <TableHeaderCorner
          allSelected={allSelected}
          showCheckboxes={showCheckboxes}
          onToggleAll={onToggleAll}
        />

        {columns.map((column) => (
            <TableHeaderCell
              key={`table_head_${column.key}`}
              column={column}
              isSortable={Boolean(column?.isSortable)}
              contextMenuTrigger="click"
              draggingKey={draggingKey}
              dragOverKey={dragOverKey}
              onDragEnd={onDragEnd}
              onDragOver={onDragOver}
              onDragStart={onDragStart}
              onDrop={onDrop}
              onResizeStart={onResizeStart}
              onSortAscending={onSortAscending}
              onSortDescending={onSortDescending}
            />
        ))}
    </div>
    );
};

// Dev Tools
TableHeader.displayName = 'TableHeader';

export default TableHeader;
